import moment from 'moment'
export default {
  "entityName": "disposed",
  upsert: 'full',
  filterStorage: {},
  "pagination": {
    "rowsPerPage": 10,
    "page": 1,
    "sortBy": "id",
    "descending": true
  },
  "fields": [
    {
      text: 'Date',
      value: 'date',
      render: item => moment(item.date).format('YYYY-MM-DD'),
      table: {
        filter: true
      },
      visible: false,
      readonly: true,
    },
    {
      "value": "protocol_id",
      "text": "Protocol",
      "type": "autocomplete",
      readonly: true,
      "table": {
        "sortable": true,
        filter: true
      },
      "title": "name",
      "subtitle": "name",
      visible: false,
    },
    {
      value: 'site.city',
      text: 'Where',
      readonly: true,
      filter: (item, search) => {
        if (search) return [
          { 'site.name': `%${search}%`}, { 'site.city': `%${search}%`}, { 'site.code': `%${search}%`},
          { 'site.id': null, 'storage.name': `%${search}%`},
          { 'disposal.name': `%${search}%` }]
      },            
      table: {
        sortable: true,
        filter: true
      },
      title: 'name',
      render: (item) => (item.site && item.site.id && `${item.site.city} - ${item.site.name}`) || item.storage && item.storage.name || item.disposal && item.disposal.name,
      // visible: item => item.site_id
    },
    {
      value: '_pdf',
      text: 'Destroy documentation',
      type: 'file',
      visible: (item, state) => item.status !== 'CANCELED' && (!['VALIDATED', 'DOCUMENTED'].includes(item.status) || state.user.role === 'Administrator' || state.user.role === 'EMN User' || state.user.role === 'Monitor'),
      validators: [
        (field, value,item) => {
          if (item.status === 'REQUESTED')
          {
            return (value) || 'Destroy documentation is required'
          }
          else
          {
            return true
          }
        }
      ]
    },
    {
      full: true,
      value: 'note',
      text: 'Reasons for destroy',
      type: 'textarea',
      readonly: true,
      visible: item => item.note
    },        
    {
      value: 'status',
      text: 'Status',
      type: 'list',
      list: ['INIT', 'REQUESTED', 'IMPORTED', 'DOCUMENTED', 'VALIDATED'],
      table: {
        sortable: true,
        filter: true
      },
      visible: false
    },
		{
			value: 'disposed_drugs.name',
			text: 'Drugs',
			id: 'id',
			filter: (item, search) => search && [{ 'disposed_drugs.name': `%${search}%` }],
			subtitle: item => `${item.dose}${item.measure_unit} - ${item.protocol.name}`,
			type: 'autocomplete',
			table: {
					filter: true,
			},
			render: item => 
					item.disposed_drugs && item.disposed_drugs.reduce((drugs, drug, idx) => drugs + `${drug.name}(${drug.dose + drug.measure_unit}, ${item.drugs[idx] && (item.drugs[idx].n_pieces + '/' + Number(item.drugs[idx].n_partially))}) ` , ''),
			visible: false
		}
  ],
  "actions": [
    "upsert",
    "audit"
  ]
}
